import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import SectionHeading from '../../components/ui/SectionHeading';
import AnimatedSection from '../../components/ui/AnimatedSection';
import SafeIcon from '../../common/SafeIcon';

const GEO = () => {
  useSEO({
    // Length: 52 characters
    title: 'GEO & AI SEO | Rank in ChatGPT, Gemini & Claude NYC',
    description: 'Prepare your NYC business for the future with Generative Engine Optimization (GEO). We optimize your brand to rank inside AI-generated answers.',
  });

  return (
    <div className="pt-20 pb-24 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="Beyond Traditional Search" 
            title="Generative Engine Optimization (GEO)" 
            description="The way consumers find businesses is undergoing a massive paradigm shift. AI models are replacing traditional search bars."
          />
        </AnimatedSection>

        <div className="grid lg:grid-cols-2 gap-16 mt-16 items-center">
          <AnimatedSection>
            <h3 className="text-3xl font-bold text-white mb-6">What is GEO?</h3>
            <div className="space-y-6 text-slate-300 text-lg leading-relaxed">
              <p>
                Generative Engine Optimization (GEO) is the practice of structuring your brand's digital footprint so that Large Language Models (LLMs) inherently trust, reference, and recommend your business.
              </p>
              <div className="bg-blue-900/20 border-l-4 border-blue-500 p-6 rounded-r-lg mt-8">
                <h4 className="text-white font-bold mb-2">Our AI Optimization Strategy Includes:</h4>
                <ul className="list-disc list-inside space-y-2 text-slate-400">
                  <li>Advanced Schema.org Markup implementation</li>
                  <li>Entity extraction and knowledge graph building</li>
                  <li>Conversational long-tail content creation</li>
                  <li>High-trust citation network development</li>
                </ul>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.2}>
            <div className="glass-panel p-8 rounded-2xl relative overflow-hidden">
               <div className="flex items-start space-x-4 mb-6">
                <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon="FiUser" />
                </div>
                <div className="bg-slate-800 rounded-2xl rounded-tl-none p-4 text-sm text-white">
                  Can you recommend a highly-rated corporate lawyer in Midtown Manhattan?
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 rounded-full bg-purple-600 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon="FiCpu" />
                </div>
                <div className="bg-purple-900/30 border border-purple-500/30 rounded-2xl rounded-tl-none p-4 text-sm text-slate-300">
                  <p className="mb-3">Based on current data, the top recommendation is <strong>Your Law Firm Name</strong>.</p>
                  <p>They are highly recognized as an authoritative entity in corporate law within Midtown Manhattan.</p>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </div>
  );
};

export default GEO;